// Reference Image: https://share.anysnap.app/fV1nFbgxYmSS
import { useEffect, useRef } from "react";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

export default function TpWidgetMicro({ className }) {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = useRef(null);
  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);
  return (
    <>
      <div className={`trustpilot-widget-micro ${className}`}>
        <div
          ref={ref} // We need a reference to this element to load the TrustBox in the effect.
          className="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="5419b732fbfb950b10de65e5"
          data-businessunit-id="5942b0540000ff0005a4a45a"
          data-style-height="24px"
          data-style-width="100%"
          data-theme="light"
          data-font-family="Lato"
          data-text-color="#303A47"
        >
          <a
            href="https://trustpilot.com/review/setmore.com?utm_medium=trustbox&utm_source=MicroStar"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              loading="lazy"
              src="https://assets.setmore.com/website/v2/images/common-images/trustpilot-widget.svg"
              alt="Trustpilot widget"
            />
          </a>
        </div>
        <style jsx>{`
          .trustpilot-widget-micro {
            width: 272px;
            height: 56px;
          }
          @media (max-width: ${viewport.mobile.lg}) {
            .trustpilot-widget-micro {
              width: 272px;
              margin: 0 auto;
            }
          }
        `}</style>
      </div>
    </>
  );
}
